import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/AlertGroup/alert-group';
export var AlertGroupInline = function AlertGroupInline(_a) {
  var className = _a.className,
      children = _a.children,
      isToast = _a.isToast,
      rest = __rest(_a, ["className", "children", "isToast"]);

  return React.createElement("ul", Object.assign({
    className: css(styles.alertGroup, className, isToast ? styles.modifiers.toast : '')
  }, rest), React.Children.toArray(children).map(function (Alert, index) {
    return React.createElement("li", {
      key: index
    }, Alert);
  }));
};